<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px" placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>

                    <el-form-item label="状态" prop="supplierLevel">
                        <el-select clearable v-model="supplierLevel" placeholder="请选择" style="width: 100px" @change="getDataList">
                            <el-option
                            v-for="item in options2"
                            :key="item.supplierLevel"
                            :label="item.label"
                            :value="item.supplierLevel">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  <el-form-item label="物料分类" prop="materialGroup">
                    <el-input size="mini" v-model="materialGroup" style="width: 150px" placeholder="物料分类" clearable @blur="getDataList"></el-input>
                  </el-form-item>
                  <el-form-item label="QMS同步状态" prop="sapSynState">
                    <el-select clearable v-model="sapSynState" placeholder="请选择" style="width: 150px" @change="getDataList">
                      <el-option
                          v-for="item in sapSynStateOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询</el-button>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="tableHeight" @selection-change="selectionChangeHandle" border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>

            <el-table-column prop="supplierLevel" header-align="center" align="center" label="状态" min-width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.supplierLevel == '0'">潜在</span>
                    <span v-if="scope.row.supplierLevel == '1'">合格</span>
                </template>
            </el-table-column>
            <el-table-column prop="venderLogin" header-align="center" align="left" label="供应商账号" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderLogin }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <el-button  type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="left" label="供应商简称" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAdd" header-align="center" align="left" label="供应商地址" width="250">
                <template slot-scope="scope">
                    {{ scope.row.venderAdd }}
                </template>
            </el-table-column>
          <el-table-column prop="venderAddquan" header-align="center" align="left" label="首家邀请子公司" width="250">
            <template slot-scope="scope">
              {{ scope.row.firstInviteSubcompany }}
            </template>
          </el-table-column>
            <el-table-column prop="venderContacts" header-align="center" align="left" label="联系人" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderContacts }}
                </template>
            </el-table-column>
            <el-table-column prop="venderMail" header-align="center" align="right" label="邮箱" width="200">
                <template slot-scope="scope">
                    {{ scope.row.venderMail }}
                </template>
            </el-table-column>
            <el-table-column prop="venderTel" header-align="center" align="right" label="联系电话" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderTel }}
                </template>
            </el-table-column>
          <el-table-column prop="sapSynState" header-align="center" align="right" label="QMS同步状态" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.sapSynState == '0'">未同步</span>
              <span v-else-if="scope.row.sapSynState == '1'">同步成功</span>
              <span v-else-if="scope.row.sapSynState == '2'">同步失败</span>
              <span v-else>{{ scope.row.sapSynState }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="materialGroup" header-align="center" align="right" label="物料分类" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.materialGroup }}
            </template>
          </el-table-column>

            <el-table-column  fixed="right" header-align="center" align="center" label="操作" min-width="140px">
                <template slot-scope="scope">
                    <el-button v-if="isAuth('supplier:passsupplierInfo:enable')" type="text" size="small"  @click="onDisposableView(scope.row)" icon="el-icon-unlock">启用</el-button>
                  <el-button v-if="scope.row.supplierLevel == '1' && (scope.row.sapSynState == '0' || scope.row.sapSynState == '2')"
                             type="text" size="small"
                             @click="syncQMS(scope.row)"
                             icon="el-icon-refresh">同步QMS</el-button>
                </template>

            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>

        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
                   style="min-height:100px" @close="closegps" :close-on-click-modal="false">
            <div style="min-hight:100px">
                <div style="margin-top:5px">
                    <div>
                        
                            <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
                                <el-tab-pane label="企业概况" name="企业概况" :key="'first'">
                                    <span slot="label"><span style="color: red">*</span> 企业概况</span>
                                    <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
                                </el-tab-pane>
                                <el-tab-pane label="主要联系人员" name="主要联系人员" :key="'second'">
                                    <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
                                    <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
                                </el-tab-pane>
                                <el-tab-pane label="企业资源情况" name="企业资源情况">
                                    <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
                                    <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
                                </el-tab-pane>
                                <el-tab-pane label="工厂及地址" name="工厂及地址">
                                    <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
                                    <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
                                </el-tab-pane>
                                <el-tab-pane label="企业经营状况" name="企业经营状况">
                                    <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
                                    <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
                                </el-tab-pane>
                                <el-tab-pane label="主要产品目录" name="主要产品目录">
                                    <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
                                    <product-info ref="productInfo" :superId="this.supplierId"></product-info>
                                </el-tab-pane>
                                <el-tab-pane label="附件上传" name="附件上传">
                                    <span slot="label"><span style="color: red">*</span> 附件上传</span>
                                    <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
                                </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {selectSupplierPage,deleteSupplierById,qmsSysState} from '@/controller/supplier'
    import AddOrUpdate from './supplier-info-add-or-update'
    // 展示供应商基本信息
    import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
    import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
    import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
    import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
    import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
    import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
    import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'
    import {supCompanyList} from "../../../../controller/sys";
    import {enableGroupSupplier} from "../../../../controller/supplier";



    export default {
        name:'GroupSupplierInfoIndex',
        data() {
            return {
              // 添加QMS同步状态下拉选项
              sapSynState: '',
              sapSynStateOptions: [
                { value: '0', label: '未同步' },
                { value: '1', label: '同步成功' },
                { value: '2', label: '同步失败' }
              ],
                dataForm: {
                    key: ''
                },
                activeName:'',
                gpsdialog: false,
                flag: '',
                gpsStatusvalflag: '',
                radio: '',
                radioSelect: '',  //选中的数据赋值给它

                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],

                venderName: '',
                materialGroup:'',
                checkCreated: true,
                checkInvited: true,
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                
                dataRule: {
                    
                    
                },

                addOrUpdateVisible: false,

                mainTainVisible: false,

                venderCode : '',

                options2:[
                    {
                        supplierLevel: '0',
                        label: '潜在'
                    },
                    {
                        supplierLevel: '1',
                        label: '合格'
                    }
                ],
                value: '',
                supplierId:'',
                supplierLevel:'',
                supplierLevelList:['0','1'],
                supCompanyList:[]
            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 260
                }
            }
        },
        components: {
            AddOrUpdate,
            EnterpriseProfile,
            ResourceInfo,
            MainContacts,
            FactoryInfo,
            BusinessInfo,
            ProductInfo,
            AttachmentUpload,
        },

        activated() {
            this.flag = this.$route.params.gpsStatusvalflag
            if (this.flag === "1") {
                this.checkCreated = true
                this.checkInvited = false
            }
            if (this.$route.query && this.$route.query.gpsStatusval && this.$route.query.gpsStatusval.length > 0) {
                this.gpsStatusval = encodeURI(JSON.stringify(this.$route.query.gpsStatusval))
            } else {
                this.gpsStatusval = ''
            }
            this.getDataList()
        },

        methods: {
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectSupplierPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName,
                    'materialGroup': this.materialGroup,
                    'freezingThaw' : this.value,
                    'supplierLevel' : this.supplierLevel,
                    'supplierLevelList' : this.supplierLevelList,
                    'sapSynState': this.sapSynState
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.starttime = data.starttime
                        this.endtime = data.endtime
                        this.interfacestarttime = data.endtime
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
          syncQMS(row) {
            this.$confirm(`确定要同步"${row.venderName}"到QMS系统吗?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              qmsSysState({'id':row.id}).then(res => {
                if (res.code === '00') {
                  this.$message({
                    message: '同步成功',
                    type: 'success',
                    duration: 1500
                  })
                  this.getDataList();
                }else {
                  this.$message({
                    message: '同步失败',
                    type: 'error',
                    duration: 1500
                  })
                  this.getDataList();
                }
            }).catch(err => {
              this.$message({
                message: '同步失败',
                type: 'error',
                duration: 1500
              })
                this.getDataList();
            })}).catch(() => {
              // 用户取消操作
            })
          },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                
                this.dataListSelections = val

                console.log(this.dataListSelections)
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },
            
            // 删除
            deleteHandle(row) {
              
                    //TODO
                    this.$message.error('开发中……')
                    
                    this.$confirm(`确定进行删除操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deleteSupplierById(
                            {id : row}
                            ).then(data => {
                            if (data && data.code === '00') {
                            this.$message({
                                message: '删除成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                                this.pageIndex = 1
                                this.getDataList()
                                }
                                
                            })
                            } else {
                            this.$message.error(data.msg)
                            }
                        })
                    })
            },


            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },


            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },

            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },


            onDisposableView(row){
              let rowDetails = row
              supCompanyList().then(res=>{
                if(res && res.code === '00'){
                  this.supCompanyList = res.body;
                  if(this.supCompanyList.length > 1){
                    this.addOrUpdateVisible = true
                    this.$nextTick(() => {
                      this.$refs.addOrUpdate.init({...row,supCompanyList:this.supCompanyList})
                    })
                  }else if(this.supCompanyList.length === 0){
                    this.$message({message:'当前用户没有子公司',type: 'warning',
                      duration: 1500,})
                  } else{
                    enableGroupSupplier({subcompanyId:res.body[0].id,supId:rowDetails.id,supplierLevel:rowDetails.supplierLevel}).then(resSub=>{
                      if(resSub && resSub.code === '00') {
                        this.$message({
                          message: '操作成功',
                          type: 'success',
                          duration: 1500,
                          onClose: () => {
                            this.getDataList()
                          }
                        })
                      }else{
                        this.$message.error(resSub.msg)
                      }
                    })
                  }
                }
              })

          },

            handleClick: function () {
                if (this.activeName === '企业概况') {
                    this.$refs.enterpriseProfile.getDataList(this.superId)
                }
                if (this.activeName === '主要联系人员') {
                    this.$refs.mainContacts.getDataList(this.superId)
                }
                if (this.activeName === '企业资源情况') {
                    this.$refs.resourceInfo.getDataList(this.superId)
                }
                if (this.activeName === '工厂及地址') {
                    this.$refs.factoryInfo.getDataList(this.superId)
                }
                if (this.activeName === '企业经营状况') {
                    this.$refs.businessInfo.getDataList(this.superId)
                }
                if (this.activeName === '体系认证情况') {
                    this.$refs.certificationInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要产品目录') {
                    this.$refs.productInfo.getDataList(this.superId)
                }
                if (this.activeName === '主要设备清单') {
                    this.$refs.equipmentList.getDataList(this.superId)
                }
                if (this.activeName === '附件上传') {
                    this.$refs.attachmentUpload.getDataList(this.superId)
                }
            },

            handleUpdate(row) {
                this.gisIdKey = row.targetId
                this.gpsPid = row.pid
                this.activeName = '企业概况'
                this.gpsdialog = true
                this.targetId = row.targetId
                this.applyformId = row.applyformId
                this.statusbotton = row.applyStatus
                this.nextapplyformId = row.nextapplyformId
                this.approveLevel = row.approveLevel
                this.updatedBy = row.updatedBy
                this.supplierId = row.venderInviteFid
                this.$nextTick(() => {
                    this.$refs.enterpriseProfile.getDataList(row.venderInviteFid)
                })
            },

            closegps() {
                this.getDataList()
            },


        }
    }
</script>

<style lang="scss">
    .button-danger { color: #F56C6C; }
    .fr { float: right; }
</style>